<mat-card class="dialog-container large-dialog new-case-dialog">
    <div class="header-container">
        <div class="details-header">
            <span>New Case</span>
            <button mat-icon-button class="close-button" [mat-dialog-close]>
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <mat-divider></mat-divider>

    <div class="search-content-container">
        <app-new-case-search-clients
            (clientSelected)="
                getSelectedClient($event)
            "></app-new-case-search-clients>
    </div>

    <mat-divider></mat-divider>

    <div class="footer">
        <div class="spacer"></div>
        <div class="button-container">
            <button [mat-dialog-close] mat-button>CANCEL</button>
        </div>
    </div>
</mat-card>
